import React from 'react';

import Input from './Input.jsx';

// region TEXT AREA

function TextAreaComponent(props) {
    return <Input.Component {...props} className="textarea--whitelabel" />
}
export default { Component: TextAreaComponent };